import { schema } from "normalizr";

export const ticketSchema = new schema.Entity(
	"ticket",
	{},
	{
		idAttribute: "tuid",
	}
);
